import {
  CloseButton as ChakraCloseButton,
  CloseButtonProps as ChakraCloseButtonProps,
  forwardRef,
} from '@chakra-ui/react';
import Icon from '../Icon/Icon';
import CloseButtonTheme from './CloseButton.theme';

type ThemeArguments = Parameters<(typeof CloseButtonTheme)['baseStyle']>[0];
export interface CloseButtonProps extends ChakraCloseButtonProps {
  size?: ThemeArguments['size'];
  colorScheme: ThemeArguments['colorScheme'];
}

const CloseButton = forwardRef<CloseButtonProps, 'button'>((props, ref) => (
  <ChakraCloseButton ref={ref} {...CloseButtonTheme.defaultProps} {...props}>
    <Icon name="Cross" />
  </ChakraCloseButton>
));

export default CloseButton;
